/**
 * @fileoverview Lazy/inline-expand description field — shows preview until clicked.
 */
import { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useT } from '@/i18n/useT';

const TaskDescriptionEditor = ({ content, onChange }) => {
  const [expanded, setExpanded] = useState(false);
  const t = useT();

  const displayText = content || t('taskdescriptioneditor.noDescription');

  return (
    <Box>
      {expanded ? (
        <TextField
          multiline
          minRows={3}
          fullWidth
          size="small"
          defaultValue={content}
          placeholder={t('taskdescriptioneditor.placeholder')}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <Box
          onClick={() => setExpanded(true)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            cursor: 'pointer',
            color: content ? 'text.secondary' : 'text.subtle',
            fontSize: '0.85em',
            '&:hover': { color: 'text.primary' },
          }}
        >
          <ExpandMoreIcon sx={{ fontSize: 16 }} />
          <Typography variant="body2" noWrap>
            {displayText}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TaskDescriptionEditor;
